import { RECAPTCHA_KEY } from '@/constants/constant';

const getReCaptchaToken = ({ action = 'default' }) => {
  return new Promise((resolve) => {
    if (typeof window === 'undefined' || !window.grecaptcha) {
      resolve(null);
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(RECAPTCHA_KEY, { action }).then((token) => {
        resolve(token);
      });
    });
  });
};

export default getReCaptchaToken;
